/* eslint-disable no-constant-binary-expression */
// /* eslint-disable no-constant-binary-expression */
import { Form } from 'react-bootstrap';
import { type FormikProps } from 'formik';
// // import { useTranslation } from 'react-i18next';
import UnApplyPrepayments from './UnApplyPrepaymentsModal';
import { memo, useState } from 'react';
import NeatixModal from '@components/Modal/NeatixModal';
import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
import { type UnApplyPrepaymentsModels } from '@store/Finance/AP/ApPayments/ApPaymentsModels';
import { Card, CardBody, CardHeader } from '@components/card/card';

interface Props {
  formik: FormikProps<any>;
  UnApplyPrepaymentsList: UnApplyPrepaymentsModels[];
  NotEditable?: boolean;
}

const ApPaymentSchedules = ({ formik, UnApplyPrepaymentsList, NotEditable = false }: Props) => {
  const { values, setFieldValue } = formik;
  const { apInvoiceLinesList, apPaymentSchedulesList, invoiceType, postedFlag } = values;

  const [showModal, setShowModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const totalInvoiceLines = apInvoiceLinesList?.reduce((sum: number, item: any) => sum + item.total, 0);
  const totalPaymentSchedules = apPaymentSchedulesList?.reduce(
    (sum: number, payment: any) => sum + Number(payment.amount),
    0
  );
  const remainingAmount = Number(totalInvoiceLines) - Number(totalPaymentSchedules);

  const handlePaymentsChange = (index: number, field: string, value: any) => {
    const updatedPayments = [...apPaymentSchedulesList];
    const payment = updatedPayments[index];

    updatedPayments[index] = {
      ...payment,
      [field]: value
    };

    if (field === 'amount') {
      const numericValue = value === '' || value === null ? 0 : Number(value);
      updatedPayments[index][field] = !isNaN(numericValue) ? numericValue : 0;

      // التأكد من أن المبلغ لا يتجاوز المبلغ المتبقي للدفعات المقدمة
      if (payment.paymentId !== null && numericValue > payment.PaymentAmountUnApply) {
        updatedPayments[index][field] = payment.PaymentAmountUnApply;
      }
    }

    formik?.setFieldValue('apPaymentSchedulesList', updatedPayments);
  };

  const handleAddPayment = () => {
    const newPayment = {
      id: null,
      amount: remainingAmount > 0 ? remainingAmount : 0,
      dueDate: new Date().toISOString().split('T')[0],
      paymentId: null
    };
    setFieldValue('apPaymentSchedulesList', [...apPaymentSchedulesList, newPayment]);
  };

  const confirmDelete = (index: number) => {
    setDeleteIndex(index);
    setShowDeleteConfirm(true);
  };

  const handleDeletePayment = () => {
    if (deleteIndex !== null) {
      const updatedPayments = apPaymentSchedulesList?.filter(
        (_: any, paymentIndex: any) => paymentIndex !== deleteIndex
      );
      setFieldValue('apPaymentSchedulesList', updatedPayments);
    }
    setShowDeleteConfirm(false);
    setDeleteIndex(null);
  };

  const handleSelectPrepayment = (item: any) => {
    const selectedAmount = item.amountUnApply > remainingAmount ? remainingAmount : item.amountUnApply;

    const prepayment = {
      id: null,
      amount: selectedAmount,
      dueDate: new Date().toISOString().split('T')[0],
      paymentId: item.id,
      PaymentAmountUnApply: item.amountUnApply,
      paymentCode: item.code,
      paymentDate: new Date(item.paymentDate).toLocaleDateString(),
      paymentAmount: item.amount
    };

    setFieldValue('apPaymentSchedulesList', [...apPaymentSchedulesList, prepayment]);
    setShowModal(false);
  };

  return (
    <>
      <div className='row'>
        <div className='col-lg-4 col-md-5'>
          <Card className='card mb-4'>
            <CardHeader>
              <h6 className='mb-0'>ملخص الدفعات</h6>
            </CardHeader>
            <CardBody>
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <span className='fw-medium'>إجمالي الفاتورة:</span>
                <span className='fw-bold text-primary'>{totalInvoiceLines?.toFixed(2) || '0.00'}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mb-3'>
                <span className='fw-medium'>إجمالي الجدولة:</span>
                <span className='fw-bold text-success'>{totalPaymentSchedules?.toFixed(2) || '0.00'}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mb-3' hidden={postedFlag}>
                <span className='fw-medium'>المتبقي:</span>
                <span className={`fw-bold ${remainingAmount < 0 ? 'text-danger' : 'text-warning'}`}>
                  {remainingAmount?.toFixed(2) || '0.00'}
                </span>
              </div>

              <div className='row g-2 mt-3' hidden={postedFlag}>
                <div className='col-12'>
                  <button
                    disabled={remainingAmount <= 0 || NotEditable}
                    type='button'
                    className='btn btn-primary w-100 d-flex align-items-center justify-content-center'
                    onClick={handleAddPayment}
                  >
                    <i className='fas fa-money-bill me-2'></i>
                    إضافة دفعة جديدة
                  </button>
                </div>
                <div className='col-12'>
                  {false && (
                    <button
                      disabled={
                        remainingAmount <= 0 || invoiceType === 'CreditMemo' || UnApplyPrepaymentsList.length === 0
                      }
                      type='button'
                      className='btn btn-outline-primary w-100 d-flex align-items-center justify-content-center'
                      onClick={() => setShowModal(true)}
                    >
                      <i className='fas fa-donate me-2'></i>
                      استخدام دفعة مقدمة
                    </button>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardHeader>
              <h6 className='mb-0'>معلومات مهمة</h6>
            </CardHeader>
            <CardBody>
              <div className='alert alert-info py-2'>
                <small>
                  <i className='fas fa-info-circle me-2'></i>
                  يمكنك إضافة دفعات جديدة طالما هناك مبلغ متبقي
                </small>
              </div>
              <div className='alert alert-warning py-2'>
                <small>
                  <i className='fas fa-exclamation-triangle me-2'></i>
                  المبلغ السلبي يعني أن مجموع الدفعات أكبر من إجمالي الفاتورة
                </small>
              </div>
            </CardBody>
          </Card>
        </div>

        <div className='col-lg-8 col-md-7'>
          <Card>
            <CardHeader className='  d-flex justify-content-between align-items-center'>
              <h6 className='mb-0'>جدول الدفعات</h6>
              <span className='badge bg-theme'>{apPaymentSchedulesList?.length || 0} دفعة</span>
            </CardHeader>
            <CardBody className='p-0'>
              <div className='table-responsive'>
                <table className='table table-hover mb-0'>
                  {/* <thead className='bg-theme bg-opacity-50'> */}
                  <thead className='table-active fw-bold shadow'>
                    <tr>
                      <th className='text-center small'>#</th>
                      <th className='text-center small'>رقم الدفعة</th>
                      <th className='text-center small'>المبلغ</th>
                      <th className='text-center small'>تاريخ الاستحقاق</th>
                      <th className='text-center small' hidden={postedFlag}>
                        الإجراءات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {apPaymentSchedulesList?.length > 0 ? (
                      apPaymentSchedulesList.map((line: any, index: any) => (
                        <tr key={index} className={line.paymentId !== null ? 'table-lightzz' : ''}>
                          <td className='text-center align-middle'>{index + 1}</td>
                          <td className='text-center align-middle'>
                            <PopoverCustom
                              childern={
                                <div className='d-flex align-items-center justify-content-center'>
                                  <Form.Control
                                    disabled={NotEditable}
                                    className='text-center border-0 bg-transparent'
                                    type='text'
                                    value={
                                      line.paymentId !== null
                                        ? `${line.paymentCode || ''} (مقدمة)`
                                        : line.paymentCode || 'دفعة عادية'
                                    }
                                    readOnly
                                  />
                                  {line.paymentId !== null && <i className='fas fa-certificate text-warning ms-2'></i>}
                                </div>
                              }
                              Header={'تفاصيل الدفعة'}
                              Body={
                                <div className='p-2'>
                                  {line.paymentId !== null ? (
                                    <>
                                      <div className='d-flex justify-content-between mb-2'>
                                        <span>رقم الدفعة:</span>
                                        <strong>{line.paymentCode}</strong>
                                      </div>
                                      <div className='d-flex justify-content-between mb-2'>
                                        <span>تاريخ الدفعة:</span>
                                        <strong>{line.paymentDate}</strong>
                                      </div>
                                      <div className='d-flex justify-content-between mb-2'>
                                        <span>مبلغ الدفعة الأصلي:</span>
                                        <strong className='text-success'>
                                          {Number(line.paymentAmount).toFixed(2)}
                                        </strong>
                                      </div>
                                      <div className='d-flex justify-content-between mb-2'>
                                        <span>المبلغ المتبقي:</span>
                                        <strong className='text-primary'>
                                          {Number(line.PaymentAmountUnApply).toFixed(2)}
                                        </strong>
                                      </div>
                                      {/* <div className='alert alert-warning py-1 mt-2'>
                                        <small>
                                          <i className='fas fa-exclamation-circle me-1'></i>
                                          لا يمكن تجاوز المبلغ المتبقي من الدفعة المقدمة
                                        </small>
                                      </div> */}
                                    </>
                                  ) : (
                                    <div className='text-center py-2'>
                                      <i className='fas fa-money-bill-wave fa-2x text-success mb-2'></i>
                                      <p>دفعة عادية - سيتم دفعها وفقًا لشروط الدفع</p>
                                    </div>
                                  )}
                                </div>
                              }
                            />
                          </td>
                          <td className='text-center align-middle'>
                            <Form.Control
                              disabled={postedFlag || NotEditable}
                              className='text-center'
                              type='number'
                              min='0'
                              step='0.01'
                              value={Number(line.amount) || ''}
                              onChange={e => handlePaymentsChange(index, 'amount', parseFloat(e.target.value))}
                              onBlur={e => {
                                let value = parseFloat(e.target.value);
                                if (isNaN(value)) value = 0;

                                // التحقق من القيمة بالنسبة للدفعات المقدمة
                                if (line.paymentId !== null && value > line.PaymentAmountUnApply) {
                                  value = line.PaymentAmountUnApply;
                                }

                                // التحقق من عدم تجاوز المبلغ المتبقي
                                if (value > remainingAmount + line.amount) {
                                  value = remainingAmount + line.amount;
                                }

                                handlePaymentsChange(index, 'amount', value);
                              }}
                            />
                          </td>
                          <td className='text-center align-middle'>
                            <Form.Control
                              disabled={postedFlag || NotEditable}
                              className='text-center'
                              type='date'
                              value={line.dueDate || ''}
                              onChange={e => handlePaymentsChange(index, 'dueDate', e.target.value)}
                            />
                          </td>
                          <td className='text-center align-middle' hidden={postedFlag}>
                            <button
                              hidden={postedFlag || NotEditable}
                              type='button'
                              className='btn btn-sm btn-outline-danger'
                              onClick={() => confirmDelete(index)}
                            >
                              <i className='fas fa-trash-alt'></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} className='text-center py-4'>
                          <i className='fas fa-receipt fa-2x text-muted mb-2'></i>
                          <p className='text-muted'>لا توجد دفعات مضافة حتى الآن</p>
                          <button
                            type='button'
                            className='btn btn-sm btn-primary'
                            onClick={handleAddPayment}
                            disabled={remainingAmount <= 0}
                          >
                            إضافة أول دفعة
                          </button>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* نافذة الدفعات المقدمة */}
      <NeatixModal
        show={showModal}
        setShow={setShowModal}
        size='lg'
        centered
        title='الدفعات المقدمة المتاحة'
        showHeader={false}
        bodyClassName='p-0'
      >
        <UnApplyPrepayments
          data={UnApplyPrepaymentsList?.filter(
            (prepayment: any) =>
              !values.apPaymentSchedulesList.some((payment: any) => payment.paymentId === prepayment.id)
          )}
          onSelectPrepayment={handleSelectPrepayment}
        />
      </NeatixModal>

      {/* تأكيد الحذف */}
      <NeatixModal show={showDeleteConfirm} setShow={setShowDeleteConfirm} size='md' centered title='تأكيد الحذف'>
        <div className='text-center py-4'>
          <i className='fas fa-exclamation-triangle fa-2x text-warning mb-3'></i>
          <h5>هل أنت متأكد من حذف هذه الدفعة؟</h5>
          <p className='text-muted'>لا يمكن التراجع عن هذه العملية بعد التنفيذ</p>
          <div className='d-flex justify-content-center mt-4'>
            <button className='btn btn-outline-secondary me-3' onClick={() => setShowDeleteConfirm(false)}>
              إلغاء
            </button>
            <button className='btn btn-danger' onClick={handleDeletePayment}>
              نعم، احذف الدفعة
            </button>
          </div>
        </div>
      </NeatixModal>
    </>
  );
};

export default memo(ApPaymentSchedules);


// ظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظظ

// import UnApplyPrepayments from './UnApplyPrepaymentsModal';
// import { Form } from 'react-bootstrap';
// import { type FormikProps } from 'formik';
// import { memo, useState } from 'react';
// import NeatixModal from '@components/Modal/NeatixModal';
// import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
// import { type UnApplyPrepaymentsModels } from '@store/Finance/AP/ApPayments/ApPaymentsModels';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { NumericFormat } from 'react-number-format';

// interface Props {
//   formik: FormikProps<any>;
//   UnApplyPrepaymentsList: UnApplyPrepaymentsModels[];
//   NotEditable?: boolean;
// }

// const ApPaymentSchedules = ({ formik, UnApplyPrepaymentsList, NotEditable = false }: Props) => {
//   const { values, setFieldValue } = formik;
//   const { apInvoiceLinesList, apPaymentSchedulesList, invoiceType, postedFlag } = values;

//   const [showModal, setShowModal] = useState(false);
//   const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

//   const formatNumber = (value: number) =>
//     new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value || 0));

//   const totalInvoiceLines = apInvoiceLinesList?.reduce((sum: number, item: any) => sum + Number(item.total || 0), 0);
//   const totalPaymentSchedules = apPaymentSchedulesList?.reduce(
//     (sum: number, payment: any) => sum + Number(payment.amount || 0),
//     0
//   );
//   const remainingAmount = Number(totalInvoiceLines) - Number(totalPaymentSchedules);

//   const handlePaymentsChange = (index: number, field: string, value: any) => {
//     const updatedPayments = [...apPaymentSchedulesList];
//     const payment = updatedPayments[index];

//     updatedPayments[index] = {
//       ...payment,
//       [field]: value
//     };

//     if (field === 'amount') {
//       const numericValue = value === '' || value === null ? 0 : Number(value);
//       updatedPayments[index][field] = !isNaN(numericValue) ? numericValue : 0;

//       // التأكد من أن المبلغ لا يتجاوز المبلغ المتبقي للدفعات المقدمة
//       if (payment.paymentId !== null && numericValue > payment.PaymentAmountUnApply) {
//         updatedPayments[index][field] = payment.PaymentAmountUnApply;
//       }
//     }

//     formik?.setFieldValue('apPaymentSchedulesList', updatedPayments);
//   };

//   const handleAddPayment = () => {
//     const newPayment = {
//       id: null,
//       amount: remainingAmount > 0 ? remainingAmount : 0,
//       dueDate: new Date().toISOString().split('T')[0],
//       paymentId: null
//     };
//     setFieldValue('apPaymentSchedulesList', [...apPaymentSchedulesList, newPayment]);
//   };

//   const confirmDelete = (index: number) => {
//     setDeleteIndex(index);
//     setShowDeleteConfirm(true);
//   };

//   const handleDeletePayment = () => {
//     if (deleteIndex !== null) {
//       const updatedPayments = apPaymentSchedulesList?.filter(
//         (_: any, paymentIndex: any) => paymentIndex !== deleteIndex
//       );
//       setFieldValue('apPaymentSchedulesList', updatedPayments);
//     }
//     setShowDeleteConfirm(false);
//     setDeleteIndex(null);
//   };

//   const handleSelectPrepayment = (item: any) => {
//     const selectedAmount = item.amountUnApply > remainingAmount ? remainingAmount : item.amountUnApply;

//     const prepayment = {
//       id: null,
//       amount: selectedAmount,
//       dueDate: new Date().toISOString().split('T')[0],
//       paymentId: item.id,
//       PaymentAmountUnApply: item.amountUnApply,
//       paymentCode: item.code,
//       paymentDate: new Date(item.paymentDate).toLocaleDateString(),
//       paymentAmount: item.amount
//     };

//     setFieldValue('apPaymentSchedulesList', [...apPaymentSchedulesList, prepayment]);
//     setShowModal(false);
//   };

//   const totals = {
//     invoiceTotal: formatNumber(totalInvoiceLines || 0),
//     scheduledTotal: formatNumber(totalPaymentSchedules || 0),
//     remainingTotal: formatNumber(remainingAmount || 0)
//   };

//   return (
//     <div className='row'>
//       {/* Summary Card */}
//       <div className='col-lg-4 col-md-5'>
//         <Card className='mb-4 border-0'>
//           <CardHeader className='d-flex justify-content-between align-items-center'>
//             <h6 className='mb-0'>
//               <i className='fas fa-calculator me-2'></i>
//               ملخص الدفعات
//             </h6>
//             <span className='badge bg-primary'>التوازن المالي</span>
//           </CardHeader>
//           <CardBody>
//             <div className='bg-inverse bg-opacity-10 p-3 rounded-0 mb-3'>
//               <div className='d-flex flex-column gap-3'>
//                 <div className='d-flex justify-content-between align-items-center'>
//                   <div className='d-flex align-items-center gap-2'>
//                     <i className='fas fa-file-invoice text-theme'></i>
//                     <span className='fw-bold'>إجمالي الفاتورة:</span>
//                   </div>
//                   <span className='fw-bold fs-5'>{totals.invoiceTotal}</span>
//                 </div>

//                 <div className='d-flex justify-content-between align-items-center'>
//                   <div className='d-flex align-items-center gap-2'>
//                     <i className='fas fa-calendar-check text-success'></i>
//                     <span className='fw-bold'>إجمالي الجدولة:</span>
//                   </div>
//                   <span className='fw-bold fs-5 text-success'>{totals.scheduledTotal}</span>
//                 </div>

//                 <div className='d-flex justify-content-between align-items-center' hidden={postedFlag}>
//                   <div className='d-flex align-items-center gap-2'>
//                     <i className={`fas fa-scale-balanced ${remainingAmount < 0 ? 'text-danger' : 'text-warning'}`}></i>
//                     <span className='fw-bold'>المتبقي:</span>
//                   </div>
//                   <span className={`fw-bold fs-5 ${remainingAmount < 0 ? 'text-danger' : 'text-warning'}`}>
//                     {totals.remainingTotal}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className='row g-2 mt-3' hidden={postedFlag}>
//               <div className='col-12'>
//                 <button
//                   disabled={remainingAmount <= 0 || NotEditable}
//                   type='button'
//                   className='btn btn-theme w-100 d-flex align-items-center justify-content-center'
//                   onClick={handleAddPayment}
//                 >
//                   <i className='fas fa-plus-circle me-2'></i>
//                   إضافة دفعة جديدة
//                 </button>
//               </div>
//               <div className='col-12'>
//                 {false && (
//                   <button
//                     disabled={
//                       remainingAmount <= 0 || invoiceType === 'CreditMemo' || UnApplyPrepaymentsList.length === 0
//                     }
//                     type='button'
//                     className='btn btn-outline-theme w-100 d-flex align-items-center justify-content-center'
//                     onClick={() => setShowModal(true)}
//                   >
//                     <i className='fas fa-hand-holding-usd me-2'></i>
//                     استخدام دفعة مقدمة
//                   </button>
//                 )}
//               </div>
//             </div>
//           </CardBody>
//         </Card>

//         <Card className='border-0'>
//           <CardHeader className='d-flex justify-content-between align-items-center'>
//             <h6 className='mb-0'>
//               <i className='fas fa-info-circle me-2'></i>
//               معلومات مهمة
//             </h6>
//             <span className='badge bg-warning text-dark'>ملاحظات</span>
//           </CardHeader>
//           <CardBody>
//             <div className='alert alert-theme alert-dismissible fade show py-2 mb-2' role='alert'>
//               <i className='fas fa-info-circle me-2'></i>
//               <small>يمكنك إضافة دفعات جديدة طالما هناك مبلغ متبقي</small>
//             </div>
//             <div className='alert alert-warning alert-dismissible fade show py-2' role='alert'>
//               <i className='fas fa-exclamation-triangle me-2'></i>
//               <small>المبلغ السلبي يعني أن مجموع الدفعات أكبر من إجمالي الفاتورة</small>
//             </div>
//           </CardBody>
//         </Card>
//       </div>

//       {/* Payment Schedule Table */}
//       <div className='col-lg-8 col-md-7'>
//         <Card className='border-0'>
//           <CardHeader className='d-flex justify-content-between align-items-center'>
//             <h6 className='mb-0'>
//               <i className='fas fa-calendar-alt me-2'></i>
//               جدول الدفعات
//             </h6>
//             <div>
//               <span className='badge bg-theme me-2'>عدد الدفعات: {apPaymentSchedulesList?.length || 0}</span>
//               <span className='badge bg-success'>المجموع: {totals.scheduledTotal}</span>
//             </div>
//           </CardHeader>
//           <CardBody className='p-0'>
//             <div className='table-responsive'>
//               <div style={{ maxHeight: '400px', overflow: 'auto', position: 'relative' }}>
//                 <table className='table table-hover mb-0'>
//                   <thead
//                     className='table-actived fw-bold'
//                     style={{
//                       position: 'sticky',
//                       top: 0,
//                       zIndex: 100,
//                       backgroundColor: 'var(--bs-table-bg)',
//                       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                     }}
//                   >
//                     <tr>
//                       <th
//                         className='text-center small'
//                         style={{
//                           width: '50px',
//                           minWidth: '50px',
//                           position: 'sticky',
//                           left: 0,
//                           backgroundColor: 'var(--bs-table-bg)',
//                           zIndex: 101,
//                           boxShadow: '2px 0 4px rgba(0,0,0,0.1)'
//                         }}
//                       >
//                         #
//                       </th>
//                       <th className='text-center small' style={{ width: '200px', minWidth: '200px' }}>
//                         رقم الدفعة
//                       </th>
//                       <th className='text-center small' style={{ width: '150px', minWidth: '150px' }}>
//                         المبلغ
//                       </th>
//                       <th className='text-center small' style={{ width: '150px', minWidth: '150px' }}>
//                         تاريخ الاستحقاق
//                       </th>
//                       <th
//                         className='text-center small'
//                         style={{ width: '100px', minWidth: '100px' }}
//                         hidden={postedFlag}
//                       >
//                         الإجراءات
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {apPaymentSchedulesList?.length > 0 ? (
//                       apPaymentSchedulesList.map((line: any, index: any) => (
//                         <tr key={index} className={line.paymentId !== null ? 'table-warning' : ''}>
//                           <td
//                             className='text-center align-middle'
//                             style={{
//                               position: 'sticky',
//                               left: 0,
//                               backgroundColor: 'var(--bs-body-bg)',
//                               zIndex: 50,
//                               boxShadow: '2px 0 4px rgba(0,0,0,0.1)'
//                             }}
//                           >
//                             <span className='badge bg-theme bg-opacity-30 fw-bold' style={{ fontSize: '0.85rem' }}>
//                               {index + 1}
//                             </span>
//                           </td>
//                           <td className='text-center align-middle'>
//                             <PopoverCustom
//                               childern={
//                                 <div className='d-flex align-items-center justify-content-center gap-2'>
//                                   <div className='fw-bold'>
//                                     {line.paymentId !== null ? `${line.paymentCode || 'دفعة مقدمة'}` : 'دفعة عادية'}
//                                   </div>
//                                   {line.paymentId !== null && (
//                                     <span className='badge bg-warning text-dark'>
//                                       <i className='fas fa-certificate me-1'></i>مقدمة
//                                     </span>
//                                   )}
//                                 </div>
//                               }
//                               Header=' تفاصيل الدفعة'
//                               // ={
//                               //   <div className='d-flex align-items-center gap-2'>
//                               //     <i className='fas fa-money-check-alt'></i>
//                               //     تفاصيل الدفعة
//                               //   </div>
//                               // }
//                               Body={
//                                 <div className='p-3'>
//                                   {line.paymentId !== null ? (
//                                     <>
//                                       <div className='bg-theme bg-opacity-10 p-3 rounded-0 mb-3'>
//                                         <div className='d-flex flex-column gap-2'>
//                                           <div className='d-flex justify-content-between'>
//                                             <span className='fw-bold'>رقم الدفعة:</span>
//                                             <strong>{line.paymentCode}</strong>
//                                           </div>
//                                           <div className='d-flex justify-content-between'>
//                                             <span className='fw-bold'>تاريخ الدفعة:</span>
//                                             <strong>{line.paymentDate}</strong>
//                                           </div>
//                                           <div className='d-flex justify-content-between'>
//                                             <span className='fw-bold'>مبلغ الدفعة الأصلي:</span>
//                                             <strong className='text-success'>
//                                               {formatNumber(line.paymentAmount || 0)}
//                                             </strong>
//                                           </div>
//                                           <div className='d-flex justify-content-between'>
//                                             <span className='fw-bold'>المبلغ المتبقي:</span>
//                                             <strong className='text-primary'>
//                                               {formatNumber(line.PaymentAmountUnApply || 0)}
//                                             </strong>
//                                           </div>
//                                         </div>
//                                       </div>
//                                       <div className='alert alert-warning py-2 mt-2'>
//                                         <i className='fas fa-exclamation-circle me-2'></i>
//                                         <small>لا يمكن تجاوز المبلغ المتبقي من الدفعة المقدمة</small>
//                                       </div>
//                                     </>
//                                   ) : (
//                                     <div className='text-center py-3'>
//                                       <i className='fas fa-money-bill-wave fa-2x text-success mb-3'></i>
//                                       <p className='fw-bold'>دفعة عادية</p>
//                                       <p className='text-muted'>سيتم دفعها وفقًا لشروط الدفع المتفق عليها</p>
//                                     </div>
//                                   )}
//                                 </div>
//                               }
//                             />
//                           </td>
//                           <td className='text-center align-middle'>
//                             <NumericFormat
//                               disabled={postedFlag || NotEditable}
//                               name={`payment-${index}-amount`}
//                               value={line.amount}
//                               thousandSeparator=','
//                               decimalSeparator='.'
//                               decimalScale={2}
//                               fixedDecimalScale={false}
//                               allowNegative={false}
//                               className='form-control form-control-sm border-theme text-center'
//                               onValueChange={v => handlePaymentsChange(index, 'amount', v.floatValue ?? 0)}
//                               onBlur={e => {
//                                 let value = parseFloat(e.target.value.replace(/,/g, ''));
//                                 if (isNaN(value)) value = 0;

//                                 if (line.paymentId !== null && value > line.PaymentAmountUnApply) {
//                                   value = line.PaymentAmountUnApply;
//                                 }

//                                 if (value > remainingAmount + Number(line.amount || 0)) {
//                                   value = remainingAmount + Number(line.amount || 0);
//                                 }

//                                 handlePaymentsChange(index, 'amount', value);
//                               }}
//                               style={{ width: '100%', minWidth: '140px' }}
//                             />
//                           </td>
//                           <td className='text-center align-middle'>
//                             <Form.Control
//                               disabled={postedFlag || NotEditable}
//                               className='form-control form-control-sm border-theme text-center'
//                               type='date'
//                               value={line.dueDate || ''}
//                               onChange={e => handlePaymentsChange(index, 'dueDate', e.target.value)}
//                               style={{ width: '100%', minWidth: '140px' }}
//                             />
//                           </td>
//                           <td className='text-center align-middle' hidden={postedFlag}>
//                             <button
//                               hidden={postedFlag || NotEditable}
//                               type='button'
//                               className='btn btn-sm btn-outline-danger rounded-circle'
//                               onClick={() => confirmDelete(index)}
//                               title='حذف الدفعة'
//                               style={{
//                                 width: '28px',
//                                 height: '28px',
//                                 padding: '0'
//                               }}
//                             >
//                               <i className='fas fa-times'></i>
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan={5} className='text-center py-4 text-muted'>
//                           <i className='fa fa-inbox fa-2x mb-2'></i>
//                           <br />
//                           لا توجد دفعات مضافة حتى الآن
//                           <br />
//                           <button
//                             type='button'
//                             className='btn btn-theme mt-3'
//                             onClick={handleAddPayment}
//                             disabled={remainingAmount <= 0}
//                           >
//                             <i className='fas fa-plus me-2'></i>
//                             إضافة أول دفعة
//                           </button>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Scroll Indicator */}
//               {apPaymentSchedulesList?.length > 5 && (
//                 <div className='mt-2 text-center'>
//                   <small className='text-muted'>
//                     <i className='fas fa-arrows-alt-v me-1'></i>
//                     اسحب لرؤية المزيد من الدفعات
//                   </small>
//                 </div>
//               )}
//             </div>
//           </CardBody>

//           {/* Footer Section */}
//           {apPaymentSchedulesList?.length > 0 && (
//             <div className='card-footer d-flex justify-content-between align-items-center'>
//               <div className='text-muted small'>
//                 <i className='fas fa-list me-1'></i>
//                 عرض {apPaymentSchedulesList?.length} من {apPaymentSchedulesList?.length} دفعة
//               </div>
//               <div className='text-theme fw-bold'>
//                 <i className='fas fa-calculator me-2'></i>
//                 إجمالي المدفوعات: {totals.scheduledTotal}
//               </div>
//             </div>
//           )}
//         </Card>
//       </div>

//       {/* نافذة الدفعات المقدمة */}
//       <NeatixModal
//         show={showModal}
//         setShow={setShowModal}
//         size='lg'
//         centered
//         title='الدفعات المقدمة المتاحة'
//         showHeader={true}
//         headerClassName='bg-theme bg-opacity-25 rounded-top-3 p-3'
//         bodyClassName='p-0'
//       >
//         <UnApplyPrepayments
//           data={UnApplyPrepaymentsList?.filter(
//             (prepayment: any) =>
//               !values.apPaymentSchedulesList.some((payment: any) => payment.paymentId === prepayment.id)
//           )}
//           onSelectPrepayment={handleSelectPrepayment}
//         />
//       </NeatixModal>

//       {/* تأكيد الحذف */}
//       <NeatixModal
//         show={showDeleteConfirm}
//         setShow={setShowDeleteConfirm}
//         size='md'
//         centered
//         title='تأكيد الحذف'
//         headerClassName='bg-danger bg-opacity-25 rounded-top-3 p-3'
//       >
//         <div className='text-center py-4'>
//           <i className='fas fa-exclamation-triangle fa-2x text-warning mb-3'></i>
//           <h5>هل أنت متأكد من حذف هذه الدفعة؟</h5>
//           <p className='text-muted'>لا يمكن التراجع عن هذه العملية بعد التنفيذ</p>
//           <div className='d-flex justify-content-center mt-4'>
//             <button className='btn btn-outline-secondary me-3' onClick={() => setShowDeleteConfirm(false)}>
//               إلغاء
//             </button>
//             <button className='btn btn-danger' onClick={handleDeletePayment}>
//               <i className='fas fa-trash me-2'></i>
//               نعم، احذف الدفعة
//             </button>
//           </div>
//         </div>
//       </NeatixModal>
//     </div>
//   );
// };

// export default memo(ApPaymentSchedules);
